import { Actions, SET_USER, SET_PROFIL } from "./actions";
import { State, initialState } from "./state";

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case SET_USER:
      return Object.assign({}, state, action.user);
    case SET_PROFIL:
      return Object.assign({}, state, {
        profil: action.profil
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/user/reducer.ts